export * from './entity-inactive-indicator.component';
